import axios from './axiosHelper'
import vue from './vueHelper'
import legacy from './legacy'

export default {
  axios,
  vue,
  legacy
}
